import {
  getToken
} from '~/utils/auth'

export default function checkAuth ({ store, userGroup }) {
  getToken()
}
